<template>
  <workOrderActivityLogSetup
    v-model:dialog="dialog"
    :data="data"
    @update:dialog="dialog = $event"
  />
  <v-app>
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Search Form</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="px-2 pt-4 pb-0">
                    <v-col md="3" cols="12">
                      <v-date-input
                        label="From Date"
                        density="compact"
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date.value.value"
                        :error-messages="from_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col md="3" cols="12">
                      <v-date-input
                        label="To Date"
                        density="compact"
                        single-line
                        prepend-icon=""
                        prepend-inner-icon="mdi mdi-calendar-month"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date.value.value"
                        :error-messages="to_date.errorMessage.value"
                        autocomplete="off"
                        clearable
                      ></v-date-input>
                    </v-col>

                    <v-col lg="2" md="2" cols="6">
                      <v-btn class="bg-brand" type="submit" ref="searchButton"
                        >Search</v-btn
                      >
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid style="margin-top: -20px;">
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
                >Work Order Record</v-expansion-panel-title
              >
              <v-expansion-panel-text>
                <v-row class="py-2">
                  <v-col md="4" cols="12">
                    <v-text-field
                      v-model="search"
                      append-inner-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                      density="compact"
                      variant="outlined"
                      bg-color="grey-lighten-4"
                      class="pl-2"
                      clearable
                    ></v-text-field>
                  </v-col>

                  <v-col md="5" cols="12">
                    <div class="d-flex align-center flex-column">
                      <v-btn-group
                        variant="outlined"
                        density="compact"
                        size="x-small"
                        divided
                      >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="success"
                          @click="exportToCSV"
                          >CSV</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="primary"
                          @click="exportToExcel"
                          >EXCEL</v-btn
                        >
                        <v-btn
                          prepend-icon="mdi mdi-download"
                          variant="flat"
                          color="red"
                          @click="exportToPDF"
                          >PDF</v-btn
                        >
                      </v-btn-group>
                    </div>
                  </v-col>
                </v-row>

                <v-data-table
                  :headers="headers"
                  :items="getSchema"
                  :loading="loading"
                  v-model:items-per-page="itemsPerPage"
                  :search="search"
                  :hover="true"
                  density="compact"
                >
                  <template v-slot:item.index="{ index }">
                    {{ ++index }}
                  </template>

                  <template v-slot:item.workorder_status.name="{ item }">
                    <v-chip
                      color="success" 
                      size="small"
                      class="text-capitalize"
                      >{{ item.workorder_status.name }}</v-chip
                    >
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      v-if="item.status == 1"
                      color="success"
                      size="small"
                      class="text-capitalize"
                      >Active</v-chip
                    >
                    <v-chip
                      v-else
                      color="red"
                      size="small"
                      class="text-capitalize"
                      >Inactive</v-chip
                    >
                  </template>

                  <template v-slot:item.actions="{ item }">
                    <v-icon
                      class="ml-2 edit-button"
                      color="primary"
                      @click="viewWorkOrder(item)"
                    >
                      mdi mdi-eye
                    </v-icon>

                    <v-tooltip text="Daily Update" location="top">
                      <template #activator="{ props }">
                        <v-icon
                          v-bind="props"
                          class="ml-2 edit-button"
                          color="primary"
                          @click="dailyUpdate(item)"
                          v-if="$updateAccess($route.fullPath) && item.status == 1"
                          style="cursor: pointer"
                        >
                          mdi mdi-update
                        </v-icon>
                      </template>
                    </v-tooltip>

                    <v-icon
                      class="ml-2 edit-button"
                      color="primary"
                      @click="goToSaleOrder(item)"
                      title="Generate Sale Order"
                      :disabled="item.lock == 1"
                      v-if="$updateAccess($route.fullPath) && item.status == 1"
                    >
                      mdi-clipboard-play-outline
                    </v-icon>
                  </template>
                </v-data-table>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import workOrderActivityLogSetup from '@/components/module/sales/workOrder/workOrderActivityLogSetup.vue';
import formattedDate from '@/plugins/dateFormatter';
import { useField, useForm } from 'vee-validate';
import { ref } from 'vue';
import { useStore } from 'vuex';
import axios from "axios";
import { saveUpdateCustomer, saveUpdateCustomerMap, saveUpdateSalesWorkOrder } from "@/store/api";
import * as yup from "yup";

export default {
  components: {
    workOrderActivityLogSetup
  },
  data: () => ({
    itemsPerPage: 10,
    panel: [0],
    loading: false,
    search: "",
    dialog: false,
    data: {},
    headers: [
      { title: "#SL", align: "center", key: "index", width: "7%", sortable: false },
      { title: "Code", key: "code", align: "left", sortable: false },
      { title: "Proposal code", key: "proposal.code", align: "left", sortable: false },
      { title: "Company Name",  key: "proposal.company_name",  align: "left",  sortable: false },
      { title: "Contact Name", key: "proposal.contact_name", align: "left", sortable: false },
      { title: "Proposal Date", key: "proposal.proposal_date", align: "left", sortable: false },
      { title: "Workorder Status", align: "center", key: "workorder_status.name", sortable: true },
      { title: "Status", align: "center", key: "status", sortable: true },
      { title: "Actions", align: "center", key: "actions", sortable: false },
    ],
  }),
  watch: {},
  created() {},
  computed: {
    getSchema() {
      return this.$store.getters.getSalesWorkOrderList;
    },
  },
  setup() {
    const { handleSubmit, resetForm } = useForm({
      validationSchema: yup.object({
        from_date: yup.date().nullable().label("From Date"),
        to_date: yup.date().nullable().label("To Date"),
      }),
    });

    const from_date = useField("from_date");
    const to_date = useField("to_date");
    const errorMessages = ref("");
    const loading = ref("");
    const store = useStore();
    const submit = handleSubmit((values) => {
      loading.value = true;
      values.from_date = formattedDate(from_date.value.value);
      values.to_date = formattedDate(to_date.value.value);
      store
        .dispatch("getSalesWorkOrderList", values)
        .then((response) => {
          loading.value = false;
        })
        .catch((error) => {
          toast.error(error.response.data.message);
        });
    });
    return {
      submit,
      from_date,
      to_date,
      errorMessages,
      loading,
    };
  },
  methods: {
    goTo(val) {
      this.$router.push({ path: val }).catch((err) => {});
    },
    async goToSaleOrder(item) {
      //console.log(item);
      if(item.proposal?.customer_id == null || item.proposal?.customer_id == '') {
          const customerData = {
            company_name: item.proposal.company_name,
            company_email: item.proposal.company_email,
            company_mobile: item.proposal.company_phone,
            company_website: item.proposal.company_website,
            company_address: item.proposal.company_address,
            company_country_id: item.proposal.company_country_id,
            contact_designation: item.proposal.contact_designation,
            business_nature: item.proposal.company_nature_of_business,
            workorder_id: item.id,
            company_type_id: 1
          };
          
        await axios.post(saveUpdateCustomer, customerData)
          .then(async (response) => {
            const customer = response.data;
            const customerMap = {
              customer_id: customer.customer_id,
              branch_id: this.$store.getters.getAuthUser.branch_id,
              status: 1
            }
            if(customer.success) {
              await axios.post(saveUpdateCustomerMap, customerMap).then(async (res) => {
                const mapRes = res.data;
                if(mapRes.success) {
                  const workOrderData = { 
                      workorder_master_id: item.id,
                      workorder_date: item.workorder_date,
                      proposal_id: item.proposal_id,
                      workorder_status_id: item.workorder_status_id,
                      status: item.status,
                      lock: 0
                    }
                  await axios.post(saveUpdateSalesWorkOrder, workOrderData).then((resp) => {
                    const orderRes = resp.data;
                    if(orderRes.success) {
                        this.$router.push({ 
                          path: "add-sale-order",
                          query: { workorder_id: item.id } 
                        });
  
                      this.$store.dispatch("getSalesWorkOrderList");
                    }
                  })
                }
              });
            }
          })
          .catch((error) => {
            console.error("Error fetching requisitions:", error);
          });
      } else {
        const workOrderData = { 
          workorder_master_id: item.id,
          workorder_date: item.workorder_date,
          proposal_id: item.proposal_id,
          workorder_status_id: item.workorder_status_id,
          status: item.status,
          lock: 0
        }
        await axios.post(saveUpdateSalesWorkOrder, workOrderData).then((resp) => {
          const orderRes = resp.data;
          if(orderRes.success) {
              this.$router.push({ 
                path: "add-sale-order",
                query: { workorder_id: item.id } 
              });

            this.$store.dispatch("getSalesWorkOrderList");
          }
        })
      }
    },
    dailyUpdate(item) {
      this.data = { ...item };
      this.dialog = true;
    },
    viewWorkOrder(item) {
      this.$store.commit("setViewingSalesLeads", item);
      this.$router.push({
        name: "crm-view-work-order",
        params: { id: item.id },
      });
    },
    exportToPDF() {
      let serialNumber = 1;
      const columns = [ "#SL", "Code", "Proposal Code", "Company Name", "Contact Name", "Proposal Date", "Workorder Status", "Status" ];
      const rows = this.getSchema.map((item) => [ serialNumber++, item.code, item.proposal.code, item.proposal.company_name, item.proposal.contact_name, item.proposal.proposal_date, item.workorder_status.name, item.status == 1 ? "Active" : "Inactive" ]);
      this.$exportTableToPDF( columns, rows, "Lead List", "lead_list_" + this.$fileDate() );
    },
    exportToExcel() {
      var data = [
        [ "#SL", "Code", "Proposal Code", "Company Name", "Contact Name", "Proposal Date", "Workorder Status", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.proposal.code, item.proposal.company_name, item.proposal.contact_name, item.proposal.proposal_date, item.workorder_status.name, item.status == 1 ? "Active" : "Inactive" ]);
      });
      this.$exportTableToExcel(data, "lead_list_" + this.$fileDate());
    },
    exportToCSV() {
      var data = [
        [ "#SL", "Code", "Proposal Code", "Company Name", "Contact Name", "Proposal Date", "Workorder Status", "Status" ],
      ];
      var serialNumber = 1;
      this.getSchema.forEach((item) => {
        data.push([ serialNumber++, item.code, item.proposal.code, item.proposal.company_name, item.proposal.contact_name, item.proposal.proposal_date, item.workorder_status.name, item.status == 1 ? "Active" : "Inactive" ]);
      });

      this.$exportTableToCSV(data, "lead_list_" + this.$fileDate());
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.searchButton.$el.click();
    });   
  },
};
</script>
